'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import contractorAction from '../../actions/contractorAction';

class ContractorList extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    static defaultProps = {
        mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"],
        roleTxt: [
            "Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive",
            "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology",
            "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker",
            "Portfolio Manager", "Team Manager", "Senior Admin Executive"
        ],
    };

    handleClick(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        index = index + this.props.page * this.props.contentNo;
        contractorAction.shouldConListShow(index);
    }

    renderPE(manageBy) {
        if (!manageBy) return;
        return (
            <div>
                <b>{manageBy.userName}</b><br />({this.props.roleTxt[manageBy.role]})<br />{manageBy.email}<br />{manageBy.handPhone}
            </div>
        );
    }
    renderAddress(streetName, blkNo, unitNo, postal) {
        return (
            <div >
                {streetName ? streetName + " , \n" : ""}
                {blkNo ? "#" + blkNo + "-" : ""}{unitNo ? unitNo + ", \n" : ""}
                {postal}
            </div>
        );
    }
    generateDateFormat(date) {
        if (date) {
            return (
                date.getDate() + "-" + this.props.mthTxt[date.getMonth()] + "-" + date.getFullYear()
            );
        }
    }
    /*
    <th>MCST</th>
    <th>ESTATE</th>
    <th>ManageBy</th>
    <th>Contractor</th>
    <th>contractor Email</th>
    <th>contact Name</th>
    <th>fax</th>
    <th>addresses</th>
    <th>status</th>
    <th>service</th>
    <th>description</th>
    <th>remark</th>
    <th>Contract Start Date</th>
    <th>Contract End Date</th>
    <th>Amount</th>
    <th>First Reminder</th>
    <th>Second Reminder</th>
    */
    renderDataList(condo, contractor, service, index, index1, index2) {
        let contractStartDate = service.contractStartDate ? this.generateDateFormat(new Date(service.contractStartDate)) : "";
        let contractEndDate = service.contractEndDate ? this.generateDateFormat(new Date(service.contractEndDate)) : "";
        let firstReminder = service.firstReminder ? this.generateDateFormat(new Date(service.firstReminder)) : "";
        let secReminder = service.secondReminder ? this.generateDateFormat(new Date(service.secondReminder)) : "";
        let lastVisit = service.lastVisit ? this.generateDateFormat(new Date(service.lastVisit)) : "";
        let dueDays = 0;
        if (service.contractEndDate) {
            dueDays = Math.ceil((new Date(service.contractEndDate).getTime() - new Date().getTime()) / 1000 / 3600 / 24);
        }

        return (
            <tr key={index2}>
                <td>{condo.mcst}</td>
                <td><Link to={'/condoSet/' + condo.mcst}>{condo.condoName}</Link></td>
                <td>{condo.noUnit}</td>
                <td>{condo.address}, {condo.postal}</td>
                <td>{this.renderPE(condo.manageBy)}</td>
                <td>{this.renderPE(condo.supervisor)}</td>
                <td><Link to={'/contractorSet/' + contractor._id}>{contractor.contractorName}</Link></td>
                <td>{service.service}</td>
                <td>{service.description}</td>
                <td>{lastVisit ? lastVisit : "--"}</td>
                <td>{this.renderAddress(contractor.streetName, contractor.blkNo, contractor.unitNo, contractor.postal)}</td>
                <td>{contractor.contactName ? contractor.contactName : "--"}</td>
                <td>{contractor.telephone ? contractor.telephone : "--"}</td>
                <td>{contractor.fax ? contractor.fax : "--"}</td>
                <td>{contractor.contractorEmail}</td>
                <td>{typeof service.status == 'number' ? this.props.statusTxt[service.status] : "--"}</td>
                <td>{contractStartDate}</td>
                <td>{contractEndDate}</td>
                <td>{firstReminder ? firstReminder : "--"}</td>
                <td>{secReminder ? secReminder : "--"}</td>
                <td>{dueDays ? dueDays : "--"}</td>
                <td>{service.amount ? "$" + service.amount : "--"}</td>
                <td>{service.remark ? service.remark : "--"}</td>
            </tr>
        )
    }
    /*
        _id: "123",
        mcst: 1234,
        condoName: "Condo A",
        manageBy: [
            { staffId: "A0001", userName: "Ho Kok Liang", role: 0, email: "HKL@gmail.com" }, 
            { staffId: "A0002", userName: "Tan Kai Lee", role: 1, email: "TKL@gmail.com" }
        ],
        contractors: [
            {
                _id: "A124",
                contractorName: "E&T Cleaning Services Pte Ltd",
                contractorEmail: "crankpwr@singnet.com.sg",
                telephone: 91112222,
                contactName: "",
                fax: "",
                addresses: [
                    { address: "Blk 446 Hougang Ave 8", unitNo: "B1-1635", postal: "530446" }
                ],
                status: 0,
                contract: [
                    { 
                        service: "Cleaning", description: "Cleaning", remark: "",
                        contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                        amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28") 
                    },
                    { 
                        service: "Electric", description: "Electric", remark: "",
                        contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                        amount: 400 , firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")
                    }
                ]
            }
            */
    renderContractorList(condo, contractor, index, index1) {
        if (!contractor.contract) {
            return this.renderDataList(condo, contractor, "", index, index1, -1);
        } else {
            return contractor.contract.map((service, index2) => {
                return this.renderDataList(condo, contractor, service, index, index1, index2);
            });
        }
    }
    renderDataLists(condo, index) {
        let body;
        if (!condo.contractors || condo.contractors.length == 0) {
            body = this.renderContractorList(condo, [], index, -1);
        } else {
            body = condo.contractors.map((contractor, index1) => {
                return (this.renderContractorList(condo, contractor, index, index1));
            });
        }

        return (
            <table className={"ctr-tb " + (condo.shouldListShow ? "est-show" : "est-hide")}>
                <tbody className="ctr-tbd">
                    {body}
                </tbody>
            </table>
        );
    }
    renderNameList(condo, index) {
        return (
            <div className="est-a-nlw" style={{ width: this.props.tableWidth + "px" }}>
                <i className={"est-a-nli " + (condo.shouldListShow ? "glyphicon glyphicon-minus" : "glyphicon glyphicon-plus")}
                    onClick={this.handleClick} data-index={index}></i>
                <div className="est-a-nl est-a-n" onClick={this.handleClick} data-index={index}>{condo.condoName} ({condo.mcst})</div>
            </div>
        );
    }
    renderMainList() {
        return this.props.contractors.map((condo, index) => {
            return (
                <div key={index}>
                    {this.renderNameList(condo, index)}
                    {this.renderDataLists(condo, index)}
                </div>
            );
        });
    }
    render() {
        return (
            <div className="atd-abd-wp">
                <div className="atd-em-lt">
                    {this.renderMainList()}
                </div>
            </div>
        );
    }
}
export default ContractorList;


// WEBPACK FOOTER //
// ./app/setComponents/contractorComponents/contractorList.js